/**
 * Kit de soporte v1 — configuración que pone cada app (ADR-0025).
 *
 * Copia del kit: no se edita en el repo; el original vive en
 * Modernizacion-LeaseMD/herramientas/plantilla/soporte y se copia con
 * `sincronizar.py`. La app llama `configurarSoporte` una vez, al arrancar o
 * cuando su autenticación está lista.
 */

export interface SoporteEntidad {
  /** Etiqueta del campo y del ticket: "Corrida", "Orden", "Contrato"… */
  etiqueta: string;
  placeholder: string;
  /** Rutas de donde se toma el id; el primer grupo de captura es el id. */
  rutas: RegExp[];
}

export interface SoporteConfig {
  /** URL de POST /api/v1/bug-reports (absoluta o relativa al sitio). */
  endpoint: string;
  /** Encabezados de autenticación de la app; se piden en cada envío. */
  headers?: () => Record<string, string> | Promise<Record<string, string>>;
  /** "include" cuando la app autentica con cookie (p. ej. un portal). */
  credentials?: RequestCredentials;
  /** La entidad de la pantalla; null = el formulario no lleva ese campo. */
  entidad: SoporteEntidad | null;
}

const ID = /^[A-Za-z0-9_-]{1,64}$/;

let actual: SoporteConfig | null = null;

export function configurarSoporte(config: SoporteConfig): void {
  actual = config;
}

export function soporteConfig(): SoporteConfig {
  if (!actual) {
    throw new Error("Falta configurarSoporte() al arrancar la app.");
  }
  return actual;
}

/** El id de la entidad en la ruta actual, si la pantalla tiene una. */
export function entidadDeRuta(
  pathname: string,
  config: SoporteConfig,
): string | null {
  for (const ruta of config.entidad?.rutas ?? []) {
    const id = ruta.exec(pathname)?.[1];
    if (id && ID.test(id)) return id;
  }
  return null;
}
